import React, { useEffect, useState } from "react";
import { Modal } from "antd";

export default function RejectAppointmentModal({
    open,
    onClose,
    onSubmit,
    appointment,
}) {
    const [reason, setReason] = useState("");
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        if (!open) return;
        setReason("");
        setRemarks("");
    }, [open]);

    const handleSubmit = () => {
        if (!reason) return;

        onSubmit?.({
            appointment,
            reason,
            remarks,
        });
    };

    const handleClose = () => {
        setReason("");
        setRemarks("");
        onClose?.();
    };

    return (
        <>
            <Modal
                title={null}
                open={open}
                onCancel={handleClose}
                footer={null}
                centered
                width={620}
                className="reject-appointment-modal"
            >
                <div className="reject-modal-header">
                    <div className="reject-modal-icon">
                        <i className="bi bi-x-octagon text-white"></i>
                    </div>

                    <div>
                        <h3>Reject Appointment</h3>
                        <p>Enter reason before rejecting this appointment</p>
                    </div>
                </div>

                <div className="reject-modal-body">
                    <div className="alert alert-warning d-flex align-items-center gap-2 mb-4">
                        <i className="bi bi-exclamation-triangle-fill"></i>
                        <span className="fw-semibold">
                            This action will mark the appointment as rejected.
                        </span>
                    </div>

                    {/* <div className="mb-4">
                        <label className="form-label fw-bold text-muted mb-2">
                            Reject Reason <span className="text-danger">*</span>
                        </label>

                        <select
                            className="form-select form-select-lg rounded-4"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        >
                            <option value="">Select Reason</option>
                            <option value="Doctor Unavailable">Doctor Unavailable</option>
                            <option value="Invalid Booking">Invalid Booking</option>
                            <option value="Duplicate Appointment">Duplicate Appointment</option>
                            <option value="Incomplete Details">Incomplete Details</option>
                        </select>
                    </div> */}

                    <div>
                        <label className="form-label fw-bold text-muted mb-2">
                            Reject Remarks
                        </label>

                        <textarea
                            rows="4"
                            className="form-control rounded-4"
                            placeholder="Enter additional remarks"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                    </div>
                </div>

                <div className="reject-modal-footer">
                    <button
                        type="button"
                        className="btn btn-light fw-bold px-4"
                        onClick={handleClose}
                    >
                        <i className="bi bi-x-circle me-2"></i>
                        Close
                    </button>

                    <button
                        type="button"
                        className="btn btn-danger fw-bold px-4"
                        onClick={handleSubmit}
                        disabled={!reason}
                    >
                        <i className="bi bi-x-octagon me-2"></i>
                        Reject
                    </button>
                </div>
            </Modal>

            <style>
                {`
                .reject-appointment-modal .ant-modal-content {
  border-radius: 20px;
  overflow: hidden;
  padding: 0;
}

.reject-modal-header {
  padding: 24px;
  background: linear-gradient(135deg, #dc2626, #f97316);
  color: #fff;
  display: flex;
  align-items: center;
  gap: 16px;
}

.reject-modal-icon {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
}

.reject-modal-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 900;
  color: #fff;
}

.reject-modal-header p {
  margin: 4px 0 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
}

.reject-modal-body {
  padding: 24px;
  background: #f8fafc;
}

.reject-modal-footer {
  padding: 16px 24px;
  background: #fff;
  border-top: 1px solid #eef2f7;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
            `}
            </style>
        </>
    );
}